import { render, staticRenderFns } from "./LandingBabyRegistryDE.vue?vue&type=template&id=20187873&scoped=true"
import script from "./LandingBabyRegistryDE.vue?vue&type=script&lang=js"
export * from "./LandingBabyRegistryDE.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20187873",
  null
  
)

export default component.exports